<template>
    <Toast position="bottom-left" group="bl" />
    <Toast position="bottom-center" group="bc" />
    <Toast position="bottom-right" group="br" />
    <Toast position="top-left" group="tl" />
    <Toast position="top-center" group="tc" />
    <Toast position="top-right" group="tr" />
</template>
<style>
.p-toast {
    z-index: 99999999;
    max-width: 90vw;
}


@media(max-width: 1024px) {
    .p-toast-bottom-right {
        right: 5px !important;
        bottom: 65px !important;
    }

    .p-toast-bottom-left {
        left: 5px !important;
        bottom: 65px !important;
    }

    .p-toast-bottom-center {
        bottom: 65px !important;
    }
}
.p-toast-bottom-center {
        right: 0!important;
        bottom: 75px !important;
    }
.p-toast-top-left {
    left: 5px !important;
    top: 75px !important;
}

.p-toast-top-right {
    right: 5px !important;
    top: 75px !important;
}

.p-toast .p-toast-message.p-toast-message-error {
    background: #e60017 !important;

}

.p-toast .p-toast-message.p-toast-message-success {
    background: #1ade87 !important
}

.p-toast .p-toast-message.p-toast-message-warn {
    background: #ffc900 !important
}

.p-toast .p-toast-message.p-toast-message-info {
    background: #00b1ff !important;

}


.p-toast .p-toast-message-content {
    color: #fff
}

.p-toast .p-toast-message-content svg {
    color: #fff
}
</style>